const getters = {
  notifications: (store) => store.notifications,
  actionAssignedToLine: (store) => store.actionAssignedToLine,
  actionSendTemplates: (store) => store.actionSendTemplates,
}

export default getters
